var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSouthkorea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_34255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.174 12C16.174 13.0435 14.3052 15.6522 12.0001 15.6522C9.69489 15.6522 7.82617 13.0435 7.82617 12C7.82617 9.69478 9.69489 7.82611 12.0001 7.82611C14.3052 7.82611 16.174 9.69478 16.174 12Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.174 12C16.174 14.3052 14.3052 16.1739 12.0001 16.1739C9.69489 16.1739 7.82617 14.3052 7.82617 12",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4238 15.6895L17.5304 14.5829L18.2682 15.3206L17.1616 16.4272L16.4238 15.6895Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5791 17.5338L15.6857 16.4272L16.4234 17.165L15.3168 18.2716L14.5791 17.5338Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6367 17.9025L19.7433 16.7959L20.4811 17.5337L19.3745 18.6403L18.6367 17.9025Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.792 19.7473L17.8986 18.6407L18.6363 19.3784L17.5297 20.485L16.792 19.7473Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5303 16.7961L18.6369 15.6895L19.3746 16.4272L18.268 17.5338L17.5303 16.7961Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6865 18.6404L16.7931 17.5338L17.5309 18.2716L16.4243 19.3782L15.6865 18.6404Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6416 8.31256L15.6907 5.36162L16.4284 4.62388L19.3793 7.57482L18.6416 8.31256Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6904 7.57513L14.5838 6.46854L15.3215 5.73083L16.4281 6.83742L15.6904 7.57513Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5352 9.41992L16.4286 8.31332L17.1663 7.57561L18.2729 8.68221L17.5352 9.41992Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9033 5.36157L16.7967 4.25497L17.5345 3.51723L18.6411 4.62383L17.9033 5.36157Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.749 7.2066L18.6424 6.10001L19.3802 5.36226L20.4868 6.46886L19.749 7.2066Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25391 16.794L7.20485 19.7449L6.4671 20.4827L3.51616 17.5318L4.25391 16.794Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20508 17.5311L8.31168 18.6377L7.57397 19.3754L6.46737 18.2688L7.20508 17.5311Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.36035 15.6871L6.46695 16.7937L5.72921 17.5315L4.62261 16.4249L5.36035 15.6871Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4668 14.5803L9.41774 17.5312L8.67999 18.2689L5.72905 15.318L6.4668 14.5803Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20508 4.25269L4.25414 7.20363L3.51639 6.46588L6.46733 3.51494L7.20508 4.25269Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31152 5.35913L5.36058 8.31007L4.62284 7.57233L7.57378 4.62139L8.31152 5.35913Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41895 6.46643L6.468 9.41737L5.73029 8.67966L8.68123 5.72872L9.41895 6.46643Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_34255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

export default __webpack_public_path__ + "media/f9bc8505.svg";
export { SvgSouthkorea as ReactComponent };